// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-media-icon[data-v-06dceea5]{display:inline-block;background-color:#ed1c2f;margin-right:9px;margin-bottom:9px;padding:.67em .5em .33em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
